




























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import InputWithValidation from '@/mixins/InputWithValidation'

@Component({
  components: {}
})
export default class VAutocompleteWithValidation extends Mixins(
  InputWithValidation
) {}
